import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { useAnimation } from 'framer-motion';
import range from 'lodash/range';
import { useInterval, useTimeoutFn } from 'react-use';

var getLoopedIndex = function getLoopedIndex(index, length) {
  return (index % length + length) % length;
};

var PREV_ICONS_COUNT = 5;
var NEXT_ICONS_COUNT = 6;
export var DISPLAYED_ICONS_COUNT = PREV_ICONS_COUNT + 1 + NEXT_ICONS_COUNT;
export var useLogoCarousel = function useLogoCarousel(_ref) {
  var icons = _ref.icons,
      delay = _ref.delay,
      duration = _ref.duration;
  var animation = useAnimation(); // Initially interval is not running because the first animation should have shorter delay

  var _useState = useState(null),
      animationInterval = _useState[0],
      setAnimationInterval = _useState[1];

  var _useState2 = useState(PREV_ICONS_COUNT),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var displayedLogosIndices = range(currentIndex - PREV_ICONS_COUNT, currentIndex + NEXT_ICONS_COUNT + 1).map(function (index) {
    return getLoopedIndex(index, icons.length);
  });
  var prevIndices = displayedLogosIndices.slice(0, PREV_ICONS_COUNT);
  var prevIcons = prevIndices.map(function (index) {
    return icons[index];
  });
  var currentIcon = icons[displayedLogosIndices[PREV_ICONS_COUNT]];
  var nextIndices = displayedLogosIndices.slice(PREV_ICONS_COUNT + 1);
  var nextIcons = nextIndices.map(function (index) {
    return icons[index];
  });

  var runAnimationStep = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return animation.start("toLeft");

            case 2:
              setCurrentIndex(function (prevIndex) {
                return getLoopedIndex(prevIndex + 1, icons.length);
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function runAnimationStep() {
      return _ref2.apply(this, arguments);
    };
  }();

  useTimeoutFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setAnimationInterval(delay + duration);
            _context2.next = 3;
            return runAnimationStep();

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), delay);
  useInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return runAnimationStep();

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), animationInterval);
  return {
    animation: animation,
    prevIcons: prevIcons,
    currentIcon: currentIcon,
    nextIcons: nextIcons,
    currentIndex: currentIndex
  };
};